import { doc, deleteDoc } from "firebase/firestore";
import { db } from "config/firebase";

export const deleteClient = async (clientId: string): Promise<void> => {
  await deleteDoc(doc(db, "clients", clientId));
}; 